(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  const announcementBarState = new WeakMap();

  function toggleWithTransition(details, open) {
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        details.open = open;
      });
      return;
    }
    details.open = open;
  }

  function setupAnnouncementBar(section) {
    const details = section.querySelector('[data-announcement-bar]');
    if (!details || announcementBarState.has(details)) return;

    const summary = details.querySelector('[data-announcement-toggle]');
    const closeBtn = details.querySelector('[data-announcement-close]');

    const onSummaryClick = (event) => {
      if (!document.startViewTransition) return;
      event.preventDefault();
      toggleWithTransition(details, !details.open);
    };

    const onCloseClick = (event) => {
      event.preventDefault();
      if (details.open) {
        toggleWithTransition(details, false);
      }
      if (summary) summary.focus();
    };

    const onKeyDown = (event) => {
      if (event.key === 'Escape' && details.open) {
        toggleWithTransition(details, false);
        if (summary) summary.focus();
      }
    };

    if (summary) summary.addEventListener('click', onSummaryClick);
    if (closeBtn) closeBtn.addEventListener('click', onCloseClick);
    details.addEventListener('keydown', onKeyDown);

    announcementBarState.set(details, { summary, closeBtn, onSummaryClick, onCloseClick, onKeyDown });
  }

  function teardownAnnouncementBar(section) {
    const details = section.querySelector('[data-announcement-bar]');
    if (!details) return;

    const state = announcementBarState.get(details);
    if (!state) return;

    if (state.summary) state.summary.removeEventListener('click', state.onSummaryClick);
    if (state.closeBtn) state.closeBtn.removeEventListener('click', state.onCloseClick);
    details.removeEventListener('keydown', state.onKeyDown);

    announcementBarState.delete(details);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.announcement-bar-section').forEach(setupAnnouncementBar);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('announcement-bar-section')) {
      setupAnnouncementBar(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.classList.contains('announcement-bar-section')) {
      teardownAnnouncementBar(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
(function() {
  'use strict';

  // Copy URL functionality
  var copyBtn = document.querySelector('[data-copy-url]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function() {
      var url = this.dataset.copyUrl;
      navigator.clipboard.writeText(url).then(function() {
        copyBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20,6 9,17 4,12"/></svg>';
        setTimeout(function() {
          copyBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>';
        }, 2000);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-seller"] && !Shopify.designMode) return;
  try {
    
(() => {
  const equalizeCardHeights = (section) => {
    const cards = Array.from(section.querySelectorAll('.product-card'));
    if (cards.length === 0) return;
    cards.forEach(card => { card.style.height = 'auto'; });
    let maxHeight = 0;
    cards.forEach(card => { if (card.offsetHeight > maxHeight) maxHeight = card.offsetHeight; });
    if (maxHeight > 0) cards.forEach(card => { card.style.height = `${maxHeight}px`; });
  };

  const initSwipeHint = (section) => {
    const grid = section.querySelector('.best-seller__grid');
    const hint = section.querySelector('.best-seller__swipe-hint');
    const dots = Array.from(section.querySelectorAll('.best-seller__dot'));
    const cards = Array.from(section.querySelectorAll('.product-card'));
    if (!grid) return;
    let hintHidden = false;
    grid.addEventListener('scroll', () => {
      if (!hintHidden && hint) { hintHidden = true; hint.classList.add('is-hidden'); }
      if (dots.length && cards.length) {
        const activeIndex = Math.round(grid.scrollLeft / (cards[0].offsetWidth + 12));
        dots.forEach((dot, i) => dot.classList.toggle('best-seller__dot--active', i === activeIndex));
      }
    }, { passive: true });
  };

  const initBestSeller = (section) => {
    if (section.dataset.initialized !== 'true') {
      section.dataset.initialized = 'true';
      section.querySelectorAll('.product-card').forEach(card => {
        const img = card.querySelector('[data-main-image]');
        if (img && !img.complete) img.addEventListener('load', () => equalizeCardHeights(section), { once: true });
      });
      initSwipeHint(section);
    }
    requestAnimationFrame(() => equalizeCardHeights(section));
    if (document.fonts?.ready) document.fonts.ready.then(() => equalizeCardHeights(section));
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.best-seller').forEach(initBestSeller);
  });
  window.addEventListener('resize', () => {
    document.querySelectorAll('.best-seller').forEach(equalizeCardHeights);
  });
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.best-seller');
    if (section) initBestSeller(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    let panel = drawer.querySelector('.cart-drawer__panel');
    let noteTimer = null;
    const DISCOUNT_STORAGE_KEY = 'cartDiscountCode';

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      if (panel) {
        panel.focus();
      }
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    function reinitialize() {
      panel = drawer.querySelector('.cart-drawer__panel');
      updateDiscountUI();
    }

    function getUpsellList() {
      return drawer.querySelector('[data-upsell-list]');
    }

    function getUpsellEmptyTemplate() {
      return drawer.querySelector('[data-upsell-empty]');
    }

    function getDiscountInput() {
      return drawer.querySelector('[data-discount-input]');
    }

    function getDiscountStatus() {
      return drawer.querySelector('[data-discount-status]');
    }

    function getUpsellProductId() {
      return drawer.dataset.upsellProductId;
    }

    function getUpsellLimit() {
      return parseInt(drawer.dataset.upsellLimit || '4', 10);
    }

    function getDiscountRedirect() {
      return drawer.dataset.discountRedirect || '/cart';
    }

    function getUpsellAddLabel() {
      return drawer.dataset.upsellAddLabel || 'Add';
    }

    function getSavedDiscount() {
      try {
        return localStorage.getItem(DISCOUNT_STORAGE_KEY) || '';
      } catch (err) {
        return '';
      }
    }

    function setSavedDiscount(code) {
      try {
        if (code) {
          localStorage.setItem(DISCOUNT_STORAGE_KEY, code);
        } else {
          localStorage.removeItem(DISCOUNT_STORAGE_KEY);
        }
      } catch (err) {}
    }

    function updateDiscountUI() {
      const input = getDiscountInput();
      const status = getDiscountStatus();
      const saved = getSavedDiscount();
      if (input && !input.value && saved) {
        input.value = saved;
      }
      if (status) {
        status.hidden = !saved;
      }
    }

    function syncDrawerAttributes(newDrawerEl) {
      if (!newDrawerEl) return;
      if (newDrawerEl.dataset.upsellProductId !== undefined) {
        drawer.dataset.upsellProductId = newDrawerEl.dataset.upsellProductId;
      }
      if (newDrawerEl.dataset.upsellLimit) {
        drawer.dataset.upsellLimit = newDrawerEl.dataset.upsellLimit;
      }
      if (newDrawerEl.dataset.discountRedirect) {
        drawer.dataset.discountRedirect = newDrawerEl.dataset.discountRedirect;
      }
      if (newDrawerEl.dataset.upsellAddLabel) {
        drawer.dataset.upsellAddLabel = newDrawerEl.dataset.upsellAddLabel;
      }
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    async function updateNote(value) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: value })
        });
      } catch (err) {
        console.error('Failed to update note:', err);
      }
    }

    function applyDiscount() {
      const input = getDiscountInput();
      if (!input) return;
      const code = input.value.trim();
      setSavedDiscount(code);
      updateDiscountUI();
    }

    function clearUpsells() {
      const list = getUpsellList();
      if (!list) return;
      while (list.firstChild) list.removeChild(list.firstChild);
    }

    function renderUpsellEmpty() {
      const list = getUpsellList();
      const emptyTemplate = getUpsellEmptyTemplate();
      if (!list || !emptyTemplate) return;
      const emptyNode = emptyTemplate.content.cloneNode(true);
      list.appendChild(emptyNode);
    }

    function renderUpsells(products) {
      const list = getUpsellList();
      if (!list) return;
      clearUpsells();
      if (!products || products.length === 0) {
        renderUpsellEmpty();
        return;
      }

      products.slice(0, getUpsellLimit()).forEach((product) => {
        const variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
        const item = document.createElement('div');
        item.className = 'cart-drawer__upsell-item';

        const media = document.createElement('a');
        media.className = 'cart-drawer__upsell-media';
        media.href = product.url;
        if (product.featured_image) {
          const img = document.createElement('img');
          img.src = product.featured_image;
          img.alt = product.title || '';
          img.loading = 'lazy';
          media.appendChild(img);
        }

        const title = document.createElement('a');
        title.className = 'cart-drawer__upsell-title-text';
        title.href = product.url;
        title.textContent = product.title;

        const price = document.createElement('div');
        price.className = 'cart-drawer__upsell-price';
        const currentPrice = document.createElement('span');
        currentPrice.className = 'cart-drawer__upsell-price-current';
        currentPrice.textContent = formatMoney(product.price);
        price.appendChild(currentPrice);

        if (product.compare_at_price && product.compare_at_price > product.price) {
          const comparePrice = document.createElement('s');
          comparePrice.className = 'cart-drawer__upsell-price-compare';
          comparePrice.textContent = formatMoney(product.compare_at_price);
          price.appendChild(comparePrice);
        }

        const actions = document.createElement('div');
        actions.className = 'cart-drawer__upsell-actions';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'cart-drawer__upsell-add';
        button.textContent = getUpsellAddLabel();
        if (variantId) {
          button.dataset.upsellAdd = '';
          button.dataset.variantId = variantId;
        } else {
          button.disabled = true;
        }

        actions.appendChild(button);

        item.appendChild(media);
        item.appendChild(title);
        item.appendChild(price);
        item.appendChild(actions);
        list.appendChild(item);
      });
    }

    async function loadUpsells() {
      const productId = getUpsellProductId();
      if (!productId) return;
      try {
        const res = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + getUpsellLimit() + '&intent=related');
        const data = await res.json();
        renderUpsells(data.products || []);
      } catch (err) {
        console.error('Failed to load recommendations:', err);
        renderUpsellEmpty();
      }
    }

    drawer.addEventListener('click', async (event) => {
      const closeTarget = event.target.closest('[data-cart-close]');
      if (closeTarget) {
        close();
        return;
      }

      const discountTarget = event.target.closest('[data-discount-apply]');
      if (discountTarget) {
        applyDiscount();
        return;
      }

      const checkoutTarget = event.target.closest('[data-checkout]');
      if (checkoutTarget) {
        const code = getSavedDiscount() || (getDiscountInput() ? getDiscountInput().value.trim() : '');
        if (code) {
          event.preventDefault();
          const url = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
          window.location.href = url;
        }
        return;
      }

      const upsellAdd = event.target.closest('[data-upsell-add]');
      if (upsellAdd) {
        const variantId = upsellAdd.dataset.variantId;
        if (!variantId) return;
        upsellAdd.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
          });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (err) {
          console.error('Failed to add upsell:', err);
        } finally {
          upsellAdd.disabled = false;
        }
        return;
      }

      const qtyTarget = event.target.closest('[data-qty-change]');
      if (!qtyTarget) return;

      event.preventDefault();
      event.stopPropagation();

      const line = parseInt(qtyTarget.dataset.line, 10);
      const quantity = parseInt(qtyTarget.dataset.qty, 10);
      const item = qtyTarget.closest('.cart-drawer__item');

      if (item) item.classList.add('is-loading');

      try {
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });
        if (res.ok) {
          /* Re-fetch section HTML to refresh drawer */
          try {
            var secRes = await fetch('/?sections=cart-drawer');
            var secData = await secRes.json();
            if (secData['cart-drawer']) {
              var temp = document.createElement('div');
              temp.innerHTML = secData['cart-drawer'];
              var newDrawer = temp.querySelector('#cart-drawer');
              if (newDrawer) {
                syncDrawerAttributes(newDrawer);
                drawer.innerHTML = newDrawer.innerHTML;
                reinitialize();
                loadUpsells();
              }
            }
          } catch (secErr) {
            window.location.reload();
            return;
          }
          /* Update header cart count + check empty */
          try {
            var cartRes = await fetch('/cart.js');
            var cartData = await cartRes.json();
            document.querySelectorAll('[data-cart-count]').forEach(function(el) {
              el.textContent = cartData.item_count;
            });
            if (cartData.item_count === 0) {
              window.location.reload();
            }
          } catch (ignore) {}
        }
      } catch (err) {
        console.error('Failed to update cart item:', err);
        if (item) item.classList.remove('is-loading');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });

    drawer.addEventListener('input', (event) => {
      if (!event.target.matches('[data-note-input]')) return;
      clearTimeout(noteTimer);
      const value = event.target.value;
      noteTimer = setTimeout(() => updateNote(value), 500);
    });

    drawer.addEventListener('keydown', (event) => {
      if (!event.target.matches('[data-discount-input]')) return;
      if (event.key === 'Enter') {
        event.preventDefault();
        applyDiscount();
      }
    });

    document.addEventListener('cart:open', open);
    document.addEventListener('cart:close', close);
    document.addEventListener('cart:open', loadUpsells);
    document.addEventListener('cart:open', updateDiscountUI);

    document.addEventListener('cart:updated', async (e) => {
      const { sections } = e.detail || {};

      if (sections && sections['cart-drawer']) {
        const temp = document.createElement('div');
        temp.innerHTML = sections['cart-drawer'];
        const newDrawer = temp.querySelector('#cart-drawer');
        if (newDrawer) {
          syncDrawerAttributes(newDrawer);
          drawer.innerHTML = newDrawer.innerHTML;
          reinitialize();
          loadUpsells();
        }
      } else {
        try {
          const res = await fetch('/?sections=cart-drawer');
          const data = await res.json();
          if (data['cart-drawer']) {
            const temp = document.createElement('div');
            temp.innerHTML = data['cart-drawer'];
            const newDrawer = temp.querySelector('#cart-drawer');
            if (newDrawer) {
              syncDrawerAttributes(newDrawer);
              drawer.innerHTML = newDrawer.innerHTML;
              reinitialize();
              loadUpsells();
            }
          }
        } catch (err) {
          console.error('Failed to update cart drawer:', err);
        }
      }
    });

    document.addEventListener('cart:refresh', () => {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (!document.querySelector('.cart-page')) {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    });

    document.documentElement.addEventListener('cart:refresh', () => {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (!document.querySelector('.cart-page')) {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  'use strict';

  function initCart(section) {
    var cartForm = section.querySelector('[data-cart-form]');
    if (!cartForm) return;

    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    var debounceTimer;
    var DISCOUNT_STORAGE_KEY = 'cartDiscountCode';

    function debounce(func, delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(func, delay);
    }

    function getDiscountInput() {
      return section.querySelector('[data-discount-input]');
    }

    function getDiscountStatus() {
      return section.querySelector('[data-discount-status]');
    }

    function getSavedDiscount() {
      try {
        return localStorage.getItem(DISCOUNT_STORAGE_KEY) || '';
      } catch (err) {
        return '';
      }
    }

    function setSavedDiscount(code) {
      try {
        if (code) {
          localStorage.setItem(DISCOUNT_STORAGE_KEY, code);
        } else {
          localStorage.removeItem(DISCOUNT_STORAGE_KEY);
        }
      } catch (err) {}
    }

    function updateDiscountUI() {
      var input = getDiscountInput();
      var status = getDiscountStatus();
      var saved = getSavedDiscount();
      var dynamicCheckout = section.querySelector('.cart-summary__dynamic-checkout');
      if (input && !input.value && saved) {
        input.value = saved;
      }
      if (status) {
        status.hidden = !saved;
      }
      if (dynamicCheckout) {
        dynamicCheckout.hidden = !!saved;
      }
    }

    function applyDiscount() {
      var input = getDiscountInput();
      if (!input) return;
      var code = (input.value || '').trim();
      setSavedDiscount(code);
      updateDiscountUI();
    }

    // Show loading state
    function setLoadingState(key, isLoading) {
      var item = section.querySelector('[data-cart-item][data-key="' + key + '"]');
      var summary = section.querySelector('.cart-summary');
      
      if (item) {
        item.classList.toggle('is-loading', isLoading);
        var linePrice = item.querySelector('[data-line-price]');
        if (linePrice) linePrice.classList.toggle('is-updating', isLoading);
      }
      if (summary) {
        summary.classList.toggle('is-loading', isLoading);
      }
    }

    // Update cart via AJAX
    function updateCart(key, quantity) {
      setLoadingState(key, true);

      var body = JSON.stringify({
        id: key,
        quantity: quantity
      });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          setLoadingState(key, false);

          if (quantity === 0) {
            var item = section.querySelector('[data-cart-item][data-key="' + key + '"]');
            if (item) {
              item.style.transition = 'opacity 0.3s, transform 0.3s';
              item.style.opacity = '0';
              item.style.transform = 'translateX(-20px)';
              setTimeout(function() { item.remove(); }, 300);
            }
          }
          
          updateCartTotals(cart);
          
          if (cart.item_count === 0) {
            window.location.reload();
          }
          
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        })
        .catch(function(err) {
          console.error('Cart update error:', err);
          setLoadingState(key, false);
        });
    }

    // Update cart totals on page
    function updateCartTotals(cart) {
      var subtotalEl = section.querySelector('[data-cart-subtotal]');
      var totalEl = section.querySelector('[data-cart-total]');
      
      if (subtotalEl) subtotalEl.textContent = Shopify.formatMoney(cart.total_price);
      if (totalEl) totalEl.textContent = Shopify.formatMoney(cart.total_price);

      cart.items.forEach(function(item) {
        var itemEl = section.querySelector('[data-cart-item][data-key="' + item.key + '"]');
        if (itemEl) {
          var linePriceEl = itemEl.querySelector('[data-line-price]');
          if (linePriceEl) linePriceEl.textContent = Shopify.formatMoney(item.final_line_price);

          var totalCol = itemEl.querySelector('.cart-item__total-col');
          if (totalCol) {
            var originalLineEl = totalCol.querySelector('.cart-item__original-line-price');
            if (item.original_line_price > item.final_line_price) {
              if (!originalLineEl) {
                originalLineEl = document.createElement('s');
                originalLineEl.className = 'cart-item__original-line-price';
                totalCol.appendChild(originalLineEl);
              }
              originalLineEl.textContent = Shopify.formatMoney(item.original_line_price);
            } else if (originalLineEl) {
              originalLineEl.remove();
            }
          }
          
          var minusBtn = itemEl.querySelector('[data-qty-change="-1"]');
          if (minusBtn) minusBtn.disabled = (item.quantity <= 1);
        }
      });
    }

    // Event Delegation scoped to Section
    section.addEventListener('click', function(e) {
      var applyBtn = e.target.closest('[data-discount-apply]');
      if (applyBtn) {
        e.preventDefault();
        applyDiscount();
        return;
      }

      var checkoutBtn = e.target.closest('[data-checkout]');
      if (checkoutBtn) {
        e.preventDefault();
        var saved = getSavedDiscount();
        var input = getDiscountInput();
        var code = saved || (input ? input.value.trim() : '');
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
        } else {
          window.location.href = '/checkout';
        }
        return;
      }

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.dataset.key;
        var change = parseInt(qtyBtn.dataset.qtyChange);
        var input = section.querySelector('[data-qty-input][data-key="' + key + '"]');
        if (input) {
          var newQty = Math.max(1, parseInt(input.value) + change);
          input.value = newQty;
          debounce(function() {
            updateCart(key, newQty);
          }, 500);
        }
      }

      var removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        e.preventDefault();
        var key = removeBtn.dataset.key;
        updateCart(key, 0);
      }
    });

    section.addEventListener('change', function(e) {
      var qtyInput = e.target.closest('[data-qty-input]');
      if (qtyInput) {
        var key = qtyInput.dataset.key;
        var qty = Math.max(0, parseInt(qtyInput.value) || 0);
        updateCart(key, qty);
      }
    });

    section.addEventListener('keydown', function(e) {
      if (!e.target.matches('[data-discount-input]')) return;
      if (e.key === 'Enter') {
        e.preventDefault();
        applyDiscount();
      }
    });

    cartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var saved = getSavedDiscount();
      var input = getDiscountInput();
      var code = saved || (input ? input.value.trim() : '');
      if (code) {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
      } else {
        window.location.href = '/checkout';
      }
    });

    // Note auto-save
    var noteTextarea = section.querySelector('#CartNote');
    if (noteTextarea) {
      var noteSaveTimer;
      noteTextarea.addEventListener('input', function() {
        clearTimeout(noteSaveTimer);
        noteSaveTimer = setTimeout(function() {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteTextarea.value })
          }).catch(console.error);
        }, 1000);
      });
    }

    updateDiscountUI();
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    var cartSection = document.querySelector('.cart-page');
    if (cartSection) initCart(cartSection);
  });

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.cart-page')) {
      initCart(e.target.querySelector('.cart-page'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function() {
  'use strict';

  var modal = null;
  var modalBody = null;
  var previousActiveElement = null;
  var isOpen = false;
  var stringsEl = document.querySelector('[data-quick-view-strings]');
  var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};

  function createModal() {
    if (modal) return;

    modal = document.createElement('div');
    modal.id = 'QuickViewModal';
    modal.className = 'quick-view-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="quick-view-modal__overlay" data-quick-view-close></div>' +
      '<div class="quick-view-modal__content">' +
      '<button type="button" class="quick-view-modal__close" data-quick-view-close aria-label="' + (strings.closeLabel || 'Close') + '">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<line x1="18" y1="6" x2="6" y2="18"></line>' +
      '<line x1="6" y1="6" x2="18" y2="18"></line>' +
      '</svg>' +
      '</button>' +
      '<div class="quick-view-modal__body" id="QuickViewBody"></div>' +
      '</div>';

    document.body.appendChild(modal);
    modalBody = document.getElementById('QuickViewBody');

    var style = document.createElement('style');
    style.id = 'QuickViewModalStyles';
    style.textContent =
      '.quick-view-modal {' +
      'position: fixed;' +
      'top: 0;' +
      'left: 0;' +
      'width: 100%;' +
      'height: 100%;' +
      'z-index: 9999;' +
      'display: flex;' +
      'justify-content: center;' +
      'align-items: center;' +
      'opacity: 0;' +
      'visibility: hidden;' +
      'transition: opacity 0.3s ease, visibility 0.3s ease;' +
      '}' +
      '.quick-view-modal.is-open {' +
      'opacity: 1;' +
      'visibility: visible;' +
      '}' +
      '.quick-view-modal__overlay {' +
      'position: absolute;' +
      'top: 0;' +
      'left: 0;' +
      'width: 100%;' +
      'height: 100%;' +
      'background: rgba(0, 0, 0, 0.5);' +
      'backdrop-filter: blur(2px);' +
      '}' +
      '.quick-view-modal__content {' +
      'position: relative;' +
      'background: #fff;' +
      'max-width: 950px;' +
      'width: 90%;' +
      'max-height: 90vh;' +
      'display: flex;' +
      'flex-direction: column;' +
      'overflow: hidden;' +
      'box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);' +
      'border-radius: 8px;' +
      'z-index: 10000;' +
      'transform: translateY(20px);' +
      'transition: transform 0.3s ease;' +
      '}' +
      '.quick-view-modal.is-open .quick-view-modal__content {' +
      'transform: translateY(0);' +
      '}' +
      '.quick-view-modal__close {' +
      'position: absolute;' +
      'top: 1rem;' +
      'right: 1rem;' +
      'width: 40px;' +
      'height: 40px;' +
      'background: #fff;' +
      'border: 1px solid #ddd;' +
      'border-radius: 50%;' +
      'cursor: pointer;' +
      'z-index: 10001;' +
      'display: flex;' +
      'align-items: center;' +
      'justify-content: center;' +
      'transition: background 0.2s, border-color 0.2s;' +
      '}' +
      '.quick-view-modal__close:hover {' +
      'background: #f5f5f5;' +
      'border-color: #999;' +
      '}' +
      '.quick-view-modal__body {' +
      'min-height: 200px;' +
      'overflow-y: auto;' +
      'flex: 1;' +
      'width: 100%;' +
      '}' +
      '.quick-view-modal__loading {' +
      'display: flex;' +
      'align-items: center;' +
      'justify-content: center;' +
      'padding: 4rem;' +
      'color: #666;' +
      'height: 100%;' +
      '}' +
      '.quick-view-modal__error {' +
      'padding: 2rem;' +
      'text-align: center;' +
      'color: #d32f2f;' +
      '}';

    document.head.appendChild(style);

    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-quick-view-close]')) {
        closeQuickView();
      }
    });
  }

  function initQuickViewContent(container) {
    var qvContainer = container.querySelector('.quick-view__container');
    if (!qvContainer) return;

    var form = qvContainer.querySelector('[data-quick-view-form]');
    var productJsonEl = qvContainer.querySelector('[data-product-json]');
    var productStringsEl = qvContainer.querySelector('[data-product-strings]');
    if (!productJsonEl || !productStringsEl) return;

    var productJson = JSON.parse(productJsonEl.textContent);
    var productStrings = JSON.parse(productStringsEl.textContent);

    var variantIdInput = qvContainer.querySelector('[data-variant-id]');
    var priceEl = qvContainer.querySelector('[data-price]');
    var comparePriceEl = qvContainer.querySelector('[data-compare-price]');
    var saleBadgeEl = qvContainer.querySelector('[data-sale-badge]');
    var addBtn = qvContainer.querySelector('[data-add-btn]');
    var thumbnails = qvContainer.querySelectorAll('[data-thumbnail-btn]');
    var optionInputs = qvContainer.querySelectorAll('[data-option-input]');
    var mediaItems = qvContainer.querySelectorAll('.quick-view__media-item');
    var qtyInput = qvContainer.querySelector('.quick-view__qty-input');
    var minusBtn = qvContainer.querySelector('[data-qty-minus]');
    var plusBtn = qvContainer.querySelector('[data-qty-plus]');

    var formatMoney = Shopify.formatMoney;

    function switchMedia(mediaId) {
      mediaItems.forEach(function(item) {
        var isActive = item.dataset.mediaId == mediaId;
        item.classList.toggle('is-active', isActive);
        if (!isActive) {
          var video = item.querySelector('video');
          if (video) video.pause();
        }
      });
      thumbnails.forEach(function(thumb) {
        var isActive = thumb.dataset.mediaId == mediaId;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function updateVariant() {
      var selectedOptions = [];
      productJson.options.forEach(function(opt, index) {
        var input = form.querySelector('input[name="option' + (index + 1) + '"]:checked');
        if (input) selectedOptions.push(input.value);
      });

      var matchedVariant = productJson.variants.find(function(variant) {
        return variant.options.length === selectedOptions.length &&
          variant.options.every(function(val, index) {
            return val === selectedOptions[index];
          });
      });

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;
        priceEl.textContent = formatMoney(matchedVariant.price);

        if (comparePriceEl && saleBadgeEl) {
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            comparePriceEl.textContent = formatMoney(matchedVariant.compare_at_price);
            comparePriceEl.style.display = '';
            saleBadgeEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
            saleBadgeEl.style.display = 'none';
          }
        }

        if (matchedVariant.available) {
          addBtn.disabled = false;
          addBtn.textContent = productStrings.addToCart;
        } else {
          addBtn.disabled = true;
          addBtn.textContent = productStrings.soldOut;
        }

        if (matchedVariant.featured_media) {
          switchMedia(matchedVariant.featured_media.id);
        }

        productJson.options.forEach(function(opt, index) {
          var valueSpan = qvContainer.querySelector('[data-option-value="' + (index + 1) + '"]');
          if (valueSpan) valueSpan.textContent = selectedOptions[index];
        });
      } else {
        addBtn.disabled = true;
        addBtn.textContent = productStrings.unavailable;
      }
    }

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        switchMedia(thumb.dataset.mediaId);
      });
    });

    optionInputs.forEach(function(input) {
      input.addEventListener('change', updateVariant);
    });

    if (minusBtn && plusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    var thumbContainer = qvContainer.querySelector('.quick-view__thumbnails');
    if (thumbContainer) {
      thumbContainer.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var thumbsArray = Array.from(thumbnails);
          var currentIndex = thumbsArray.findIndex(function(t) {
            return t.classList.contains('is-active');
          });
          var nextIndex;
          if (e.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % thumbsArray.length;
          } else {
            nextIndex = (currentIndex - 1 + thumbsArray.length) % thumbsArray.length;
          }
          thumbsArray[nextIndex].click();
          thumbsArray[nextIndex].focus();
        }
      });
    }
  }

  function openQuickView(handle) {
    if (!handle) return;

    createModal();
    previousActiveElement = document.activeElement;

    modalBody.innerHTML = '<div class="quick-view-modal__loading">' + (strings.loading || 'Loading...') + '</div>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;

    var url = '/products/' + handle + '?section_id=quick-view';
    fetch(url)
      .then(function(res) {
        if (!res.ok) throw new Error('Product not found');
        return res.text();
      })
      .then(function(html) {
        modalBody.innerHTML = html;
        initQuickViewContent(modalBody);

        var firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
          firstFocusable.focus();
        }

        var form = modalBody.querySelector('form');
        if (form) {
          form.addEventListener('submit', handleFormSubmit);
        }
      })
      .catch(function() {
        modalBody.innerHTML = '<div class="quick-view-modal__error">' + (strings.error || 'Error loading product. Please try again.') + '</div>';
      });
  }

  function closeQuickView() {
    if (!modal || !isOpen) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;

    setTimeout(function() {
      if (!isOpen && modalBody) {
        modalBody.innerHTML = '';
      }
    }, 300);

    if (previousActiveElement) {
      previousActiveElement.focus();
      previousActiveElement = null;
    }
  }

  function handleFormSubmit(e) {
    e.preventDefault();

    var form = e.target;
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn.textContent;

    submitBtn.disabled = true;
    submitBtn.textContent = strings.adding || 'Adding...';

    var formData = new FormData(form);
    var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    fetch(cartUrl, {
      method: 'POST',
      body: formData
    })
      .then(function(res) {
        return res.json();
      })
      .then(function(data) {
        if (data.status === 422) {
          throw new Error(data.description || 'Error adding to cart');
        }
        submitBtn.textContent = strings.added || 'Added!';

        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
          });

        setTimeout(function() {
          closeQuickView();
        }, 1000);
      })
      .catch(function() {
        submitBtn.textContent = strings.errorAdd || 'Error';
        setTimeout(function() {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      });
  }

  function handleKeyDown(e) {
    if (!isOpen) return;

    if (e.key === 'Escape') {
      closeQuickView();
      return;
    }

    if (e.key === 'Tab') {
      var focusableElements = modal.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      if (focusableElements.length === 0) return;

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }

  function handleTriggerClick(e) {
    var trigger = e.target.closest('[data-quick-view-trigger]');
    if (trigger) {
      e.preventDefault();
      var handle = trigger.dataset.productHandle;
      if (handle) openQuickView(handle);
    }
  }

  function initQuickViewTriggers() {
    if (window.__quickViewInitialized) return;
    window.__quickViewInitialized = true;
    document.addEventListener('click', handleTriggerClick);
    document.addEventListener('keydown', handleKeyDown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickViewTriggers);
  } else {
    initQuickViewTriggers();
  }

  window.openQuickView = openQuickView;
  window.closeQuickView = closeQuickView;

  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url.toString();
    });
  }

  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    var debounceTimer;

    function debounce(func, delay) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(func, delay);
    }

    var checkboxes = filterForm.querySelectorAll('[data-filter-checkbox]');
    checkboxes.forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        filterForm.submit();
      });
    });

    var priceInputs = filterForm.querySelectorAll('[data-filter-price]');
    priceInputs.forEach(function(input) {
      input.addEventListener('input', function() {
        debounce(function() {
          filterForm.submit();
        }, 1000);
      });

      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          clearTimeout(debounceTimer);
          filterForm.submit();
        }
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  'use strict';

  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var menuToggle = header.querySelector('[data-menu-toggle]');
    var menuControls = menuToggle ? menuToggle.getAttribute('aria-controls') : null;
    var mobileMenu = menuControls ? document.getElementById(menuControls) : null;
    var menuCloseButtons = mobileMenu ? mobileMenu.querySelectorAll('[data-menu-close]') : [];

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        var isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', String(!isExpanded));
        mobileMenu.classList.toggle('is-open');
        document.body.style.overflow = isExpanded ? '' : 'hidden';
      });

      menuCloseButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          menuToggle.setAttribute('aria-expanded', 'false');
          mobileMenu.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      });
    }

    // Expandable menu items
    var expandButtons = mobileMenu ? mobileMenu.querySelectorAll('[data-expand-btn]') : [];
    expandButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var parent = btn.closest('.mobile-menu__item--expandable');
        if (parent) {
          parent.classList.toggle('is-expanded');
        }
      });
    });

    // Search Overlay
    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchControls = searchToggle ? searchToggle.getAttribute('aria-controls') : null;
    var searchOverlay = searchControls ? document.getElementById(searchControls) : null;
    var searchClose = document.querySelector('[data-search-close]');
    var searchInput = searchOverlay ? searchOverlay.querySelector('input[type="search"]') : null;
    var localizationForm = header.querySelector('.header__localization-form');
    var localizationButton = localizationForm ? localizationForm.querySelector('.disclosure__button') : null;
    var localizationListWrapper = localizationForm ? localizationForm.querySelector('.disclosure__list-wrapper') : null;
    var localizationLinks = localizationForm ? localizationForm.querySelectorAll('.disclosure__link') : [];
    var localizationInput = localizationForm ? localizationForm.querySelector('input[name="locale_code"]') : null;

    if (localizationForm && localizationButton && localizationListWrapper) {
      localizationButton.addEventListener('click', function() {
        var isExpanded = localizationButton.getAttribute('aria-expanded') === 'true';
        localizationButton.setAttribute('aria-expanded', String(!isExpanded));
        localizationListWrapper.hidden = isExpanded;
      });

      localizationLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          var value = link.getAttribute('data-value');
          if (!value || !localizationInput) return;
          localizationInput.value = value;
          localizationForm.submit();
        });
      });
    }

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function() {
        searchOverlay.classList.add('is-open');
        searchToggle.setAttribute('aria-expanded', 'true');
        if (searchInput) {
            setTimeout(() => searchInput.focus(), 50); 
        }
      });

      if (searchClose) {
        searchClose.addEventListener('click', function() {
          searchOverlay.classList.remove('is-open');
          searchToggle.setAttribute('aria-expanded', 'false');
          searchToggle.focus();
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
          searchOverlay.classList.remove('is-open');
          searchToggle.setAttribute('aria-expanded', 'false');
          searchToggle.focus(); // Return focus
        }
      });
    }

    document.addEventListener('cart:refresh', function(e) {
      var cart = e.detail;
      var countEl = header.querySelector('[data-cart-count]');
      if (countEl && cart) {
        if (cart.item_count > 0) {
          countEl.textContent = cart.item_count;
          countEl.style.display = 'flex'; // Ensure flex display
        } else {
          countEl.style.display = 'none';
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerSlider {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('[data-slide-index]'));
      this.thumbs = Array.from(container.querySelectorAll('[data-thumb-index]'));

      if (this.slides.length === 0) return;

      this.currentIndex = 0;
      this.isAnimating = false;
      this.autoPlayTimer = null;
      this.transitionCleanupTimer = null;

      this.config = {
        autoPlayInterval: 5000,
        transitionDuration: 400,
        swipeThreshold: 50,
        prefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches
      };

      this.touch = { startX: 0, startY: 0, deltaX: 0, isActive: false };
      this.abortController = new AbortController();

      this.init();
    }

    init() {
      this.syncState(0, false);
      this.bindEvents();
      this.startAutoPlay();
    }

    bindEvents() {
      const signal = this.abortController.signal;

      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.goTo(index), { signal });
      });
      this.container.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true, signal });
      this.container.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false, signal });
      this.container.addEventListener('touchend', () => this.handleTouchEnd(), { signal });
      this.container.addEventListener('mouseenter', () => this.pauseAutoPlay(), { signal });
      this.container.addEventListener('mouseleave', () => this.startAutoPlay(), { signal });
      this.container.addEventListener('focusin', () => this.pauseAutoPlay(), { signal });
      this.container.addEventListener('focusout', (e) => {
        if (!this.container.contains(e.relatedTarget)) this.startAutoPlay();
      }, { signal });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAutoPlay();
        } else {
          if (document.activeElement && this.container.contains(document.activeElement)) {
            document.activeElement.blur();
          }
          this.startAutoPlay();
        }
      }, { signal });
    }

    syncState(index, animate = true) {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex && animate) return;
      if (this.isAnimating) return;

      const prevIndex = this.currentIndex;
      this.currentIndex = index;

      this.updateThumbs(index);

      if (!animate || this.config.prefersReducedMotion) {
        this.updateSlidesImmediate(index);
        return;
      }

      this.animateSlideTransition(prevIndex, index);
    }

    updateThumbs(activeIndex) {
      this.thumbs.forEach((thumb, i) => {
        const isActive = i === activeIndex;
        thumb.classList.toggle('hero-banner__thumb--active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
        thumb.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    updateSlidesImmediate(activeIndex) {
      this.slides.forEach((slide, i) => {
        const isActive = i === activeIndex;
        slide.classList.remove('hero-banner__slide--entering');
        slide.classList.toggle('hero-banner__slide--active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        if (isActive) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    }

    animateSlideTransition(fromIndex, toIndex) {
      const fromSlide = this.slides[fromIndex];
      const toSlide = this.slides[toIndex];

      if (!fromSlide || !toSlide) {
        this.updateSlidesImmediate(toIndex);
        return;
      }

      this.isAnimating = true;
      this.pauseAutoPlay();
      this.clearTransitionTimer();

      toSlide.classList.add('hero-banner__slide--entering');
      toSlide.setAttribute('aria-hidden', 'false');
      fromSlide.setAttribute('aria-hidden', 'true');
      toSlide.removeAttribute('inert');
      fromSlide.setAttribute('inert', '');

      void toSlide.offsetHeight;

      toSlide.classList.add('hero-banner__slide--active');

      const cleanup = () => {
        this.clearTransitionTimer();
        fromSlide.classList.remove('hero-banner__slide--active');
        toSlide.classList.remove('hero-banner__slide--entering');
        this.isAnimating = false;
        this.startAutoPlay();
      };

      const onTransitionEnd = (e) => {
        if (e.target !== toSlide || e.propertyName !== 'opacity') return;
        toSlide.removeEventListener('transitionend', onTransitionEnd);
        cleanup();
      };

      toSlide.addEventListener('transitionend', onTransitionEnd);

      this.transitionCleanupTimer = setTimeout(() => {
        toSlide.removeEventListener('transitionend', onTransitionEnd);
        cleanup();
      }, this.config.transitionDuration + 50);
    }

    clearTransitionTimer() {
      if (this.transitionCleanupTimer) {
        clearTimeout(this.transitionCleanupTimer);
        this.transitionCleanupTimer = null;
      }
    }

    goTo(index) { this.syncState(index, true); }
    next() { this.goTo((this.currentIndex + 1) % this.slides.length); }
    prev() { this.goTo((this.currentIndex - 1 + this.slides.length) % this.slides.length); }

    startAutoPlay() {
      if (this.slides.length < 2 || this.config.prefersReducedMotion) return;
      this.pauseAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        if (!this.isAnimating) this.next();
      }, this.config.autoPlayInterval);
    }

    pauseAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    }

    handleTouchStart(e) {
      if (this.slides.length < 2) return;
      if (e.touches.length !== 1) return;
      this.touch.startX = e.touches[0].clientX;
      this.touch.startY = e.touches[0].clientY;
      this.touch.deltaX = 0;
      this.touch.isActive = true;
      this.pauseAutoPlay();
    }

    handleTouchMove(e) {
      if (!this.touch.isActive || e.touches.length !== 1) return;
      const touch = e.touches[0];
      this.touch.deltaX = touch.clientX - this.touch.startX;
      const deltaY = Math.abs(touch.clientY - this.touch.startY);
      if (Math.abs(this.touch.deltaX) > deltaY && Math.abs(this.touch.deltaX) > 10) {
        e.preventDefault();
      }
    }

    handleTouchEnd() {
      if (!this.touch.isActive) return;
      this.touch.isActive = false;
      if (Math.abs(this.touch.deltaX) >= this.config.swipeThreshold) {
        this.touch.deltaX < 0 ? this.next() : this.prev();
      }
      this.startAutoPlay();
    }

    destroy() {
      this.abortController.abort();
      this.pauseAutoPlay();
      this.clearTransitionTimer();
    }
  }

  (function() {
    const instances = new WeakMap();

    function initHeroBanner(root) {
      root.querySelectorAll('[data-hero-banner]').forEach(container => {
        if (instances.has(container)) return;
        const slider = new HeroBannerSlider(container);
        instances.set(container, slider);
      });
    }

    function destroyHeroBanner(root) {
      root.querySelectorAll('[data-hero-banner]').forEach(container => {
        const slider = instances.get(container);
        if (slider) {
          slider.destroy();
          instances.delete(container);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initHeroBanner(document));
    } else {
      initHeroBanner(document);
    }

    document.addEventListener('shopify:section:load', (e) => initHeroBanner(e.target));
    document.addEventListener('shopify:section:unload', (e) => destroyHeroBanner(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
(function() {
  'use strict';

  // Password form toggle
  var toggle = document.querySelector('[data-password-toggle]');
  var formWrapper = document.querySelector('[data-password-form]');
  
  if (toggle && formWrapper) {
    toggle.addEventListener('click', function() {
      formWrapper.classList.toggle('is-open');
      if (formWrapper.classList.contains('is-open')) {
        formWrapper.querySelector('input').focus();
      }
    });
  }

  // Countdown timer
  var countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    var targetDate = new Date(countdownEl.dataset.countdown).getTime();
    
    function updateCountdown() {
      var now = new Date().getTime();
      var distance = targetDate - now;
      
      if (distance < 0) {
        countdownEl.innerHTML = '<p>We are live!</p>';
        return;
      }
      
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      countdownEl.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
      countdownEl.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      countdownEl.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      countdownEl.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    }
    
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pixar-rusher-description"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initFeatures(container) {
      const navBtns = container.querySelectorAll('.prd-desc__features-navbtn');
      const panels = container.querySelectorAll('.prd-desc__features-panel');
      navBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.target;
          navBtns.forEach(b => b.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));
          btn.classList.add('is-active');
          container.querySelector(`[data-panel="${target}"]`)?.classList.add('is-active');
        });
      });
    }

    function init() {
      document.querySelectorAll('.prd-desc__features').forEach(initFeatures);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-view"]) return;
  try {
    
(function() {
  function initQuickViewGallery(container) {
    if (!container) return;
    
    const gallery = container.querySelector('[data-quick-view-gallery]');
    const thumbnails = container.querySelectorAll('[data-thumbnail-btn]');
    const mediaItems = container.querySelectorAll('.quick-view__media-item');
    
    if (!gallery || mediaItems.length < 2) return;

    function switchMedia(mediaId) {
      mediaItems.forEach(function(item) {
        const isActive = item.dataset.mediaId == mediaId;
        item.classList.toggle('is-active', isActive);
        if (!isActive) {
          const video = item.querySelector('video');
          if (video) video.pause();
        }
      });

      thumbnails.forEach(function(thumb) {
        const isActive = thumb.dataset.mediaId == mediaId;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        switchMedia(thumb.dataset.mediaId);
      });
    });

    let touchStartX = 0;
    let touchStartY = 0;
    const minSwipeDistance = 50;
    const maxVerticalDistance = 100;

    function getCurrentMediaIndex() {
      const mediaArray = Array.from(mediaItems);
      return mediaArray.findIndex(function(item) {
        return item.classList.contains('is-active');
      });
    }

    function switchToIndex(index) {
      const mediaArray = Array.from(mediaItems);
      if (index >= 0 && index < mediaArray.length) {
        const targetMediaId = mediaArray[index].dataset.mediaId;
        switchMedia(targetMediaId);
      }
    }

    gallery.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    gallery.addEventListener('touchend', function(e) {
      const touchEndX = e.changedTouches[0].screenX;
      const touchEndY = e.changedTouches[0].screenY;
      const horizontalDistance = touchEndX - touchStartX;
      const verticalDistance = Math.abs(touchEndY - touchStartY);

      if (Math.abs(horizontalDistance) > minSwipeDistance && verticalDistance < maxVerticalDistance) {
        const currentIndex = getCurrentMediaIndex();
        const mediaArray = Array.from(mediaItems);

        if (horizontalDistance < 0) {
          const nextIndex = (currentIndex + 1) % mediaArray.length;
          switchToIndex(nextIndex);
        } else {
          const prevIndex = (currentIndex - 1 + mediaArray.length) % mediaArray.length;
          switchToIndex(prevIndex);
        }
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initQuickViewGallery(document.querySelector('.quick-view__container'));
    });
  } else {
    initQuickViewGallery(document.querySelector('.quick-view__container'));
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function() {
  'use strict';

  var searchForm = document.querySelector('[data-search-form]');
  if (!searchForm) return;

  // Auto-submit on filter change
  var filterInputs = searchForm.querySelectorAll('.search-filter input');
  filterInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      searchForm.submit();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();

  const initSection = (container) => {
    if (!container) return;
    const existing = instances.get(container);
    if (existing) existing.cleanup();

    const track = container.querySelector('.fc-track');
    const successText = container.dataset.addSuccessText || '';
    const errorText = container.dataset.addErrorText || '';
    if (!track) return;
    let items = Array.from(track.children);

    if (items.length < 3) return;

    const cloneCount = 3;
    let resizeObserver = null;
    let resizeTimer = null;
    let animationTimer = null;
    let allItems = [];
    let currentIndex = cloneCount;
    let isAnimating = false;

    const controller = new AbortController();
    const { signal } = controller;

    const createClone = (item) => {
      const clone = item.cloneNode(true);
      clone.classList.add('fc-clone');
      clone.dataset.originalIndex = item.dataset.index;
      clone.removeAttribute('data-shopify-editor-block');
      return clone;
    };

    const firstClones = items.slice(0, cloneCount).map(createClone);
    const lastClones = items.slice(-cloneCount).map(createClone);

    firstClones.forEach((clone) => track.appendChild(clone));
    lastClones.reverse().forEach((clone) => track.insertBefore(clone, track.firstChild));

    allItems = Array.from(track.children);
    const animationDuration = parseFloat(getComputedStyle(container).getPropertyValue('--fc-animation-duration') || '500');

    const updatePosition = (enableTransition) => {
      if (enableTransition) {
        track.style.transition = `transform ${animationDuration}ms cubic-bezier(0.25, 1, 0.5, 1)`;
        container.classList.remove('fc-no-transition');
      } else {
        track.style.transition = 'none';
        container.classList.add('fc-no-transition');
        void track.offsetWidth;
      }

      const itemWidth = allItems[0].offsetWidth;
      const containerWidth = container.querySelector('.fc-viewport').offsetWidth;
      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.gap || '20px');

      const centerOfContainer = containerWidth / 2;
      const centerOfItem = (currentIndex * (itemWidth + gap)) + (itemWidth / 2);
      const moveX = centerOfContainer - centerOfItem;

      track.style.transform = `translateX(${moveX}px)`;

      allItems.forEach((item) => item.classList.remove('is-active', 'is-adj'));
      allItems[currentIndex].classList.add('is-active');

      if (allItems[currentIndex - 1]) allItems[currentIndex - 1].classList.add('is-adj');
      if (allItems[currentIndex + 1]) allItems[currentIndex + 1].classList.add('is-adj');
    };

    const destroy = () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      clearTimeout(resizeTimer);
      clearTimeout(animationTimer);
      controller.abort();
    };

    const handleTrackClick = (event) => {
      const item = event.target.closest('.fc-item');
      if (!item) return;

      if (event.target.closest('.fc-btn-add')) {
        event.preventDefault();
        event.stopPropagation();
        addToCart(item);
        return;
      }

      const clickedIndex = allItems.indexOf(item);
      if (clickedIndex === -1) return;
      if (clickedIndex === currentIndex) return;

      if (Math.abs(clickedIndex - currentIndex) === 1) {
        slide(clickedIndex);
      }
    };

    const slide = (newIndex) => {
      if (newIndex < 0 || newIndex >= allItems.length) return;

      if (isAnimating) {
        clearTimeout(animationTimer);
        isAnimating = false;
        checkLoop();
      }

      isAnimating = true;
      currentIndex = newIndex;
      updatePosition(true);

      animationTimer = setTimeout(() => {
        isAnimating = false;
        checkLoop();
      }, animationDuration);
    };

    const checkLoop = () => {
      const totalReal = items.length;
      let jumped = false;

      if (currentIndex >= cloneCount + totalReal) {
        currentIndex = currentIndex - totalReal;
        jumped = true;
      } else if (currentIndex < cloneCount) {
        currentIndex = currentIndex + totalReal;
        jumped = true;
      }

      if (jumped) updatePosition(false);
    };

    const addToCart = async (item) => {
      let variantId = item.dataset.variantId;
      if (item.classList.contains('fc-clone') && item.dataset.originalIndex !== undefined) {
        const realItem = items[parseInt(item.dataset.originalIndex, 10)];
        if (realItem) variantId = realItem.dataset.variantId;
      }
      if (!variantId) return;

      const btn = item.querySelector('.fc-btn-add');
      if (!btn) return;
      const statusEl = btn.querySelector('.fc-btn-status');
      btn.classList.add('loading');
      btn.disabled = true;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }]
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        statusEl.textContent = successText;
        btn.classList.add('success');

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: data
        }));

        setTimeout(() => {
          statusEl.textContent = '';
          btn.classList.remove('success');
        }, 3000);
      } catch (err) {
        statusEl.textContent = errorText;
        btn.classList.add('error');

        setTimeout(() => {
          statusEl.textContent = '';
          btn.classList.remove('error');
        }, 3000);
      } finally {
        btn.classList.remove('loading');
        btn.disabled = false;
      }
    };

    requestAnimationFrame(() => {
      updatePosition(false);
    });

    setTimeout(() => {
      updatePosition(false);
    }, 300);

    track.addEventListener('click', handleTrackClick, { signal });

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updatePosition(false);
        }, 100);
      });
      resizeObserver.observe(container);
    } else {
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updatePosition(false);
        }, 100);
      }, { signal });
    }

    container.setAttribute('tabindex', '0');
    container.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        slide(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        slide(currentIndex + 1);
      }
    }, { signal });

    let touchStartX = 0;
    let touchStartY = 0;
    let isSwiping = false;
    const swipeThreshold = 50;

    track.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].screenX;
      touchStartY = event.changedTouches[0].screenY;
      isSwiping = false;
    }, { passive: true, signal });

    track.addEventListener('touchmove', (event) => {
      const diffX = Math.abs(event.changedTouches[0].screenX - touchStartX);
      const diffY = Math.abs(event.changedTouches[0].screenY - touchStartY);
      if (diffX > diffY && diffX > 10) {
        isSwiping = true;
      }
    }, { passive: true, signal });

    track.addEventListener('touchend', (event) => {
      if (!isSwiping) return;
      const diffX = touchStartX - event.changedTouches[0].screenX;
      if (Math.abs(diffX) > swipeThreshold) {
        slide(currentIndex + (diffX > 0 ? 1 : -1));
      }
    }, { passive: true, signal });

    instances.set(container, { cleanup: destroy });
  };

  const initAll = () => {
    document.querySelectorAll('[data-fc-section]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-fc-section]') || event.target.closest('[data-fc-section]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-fc-section]') || event.target.closest('[data-fc-section]');
    if (!section) return;
    const instance = instances.get(section);
    if (instance) instance.cleanup();
    instances.delete(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
